import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import './tile.stamen'

// function loadScript (src) {
//   return new Promise(function (resolve, reject) {
//     var s
//     s = document.createElement('script')
//     s.src = src
//     s.onload = resolve
//     s.onerror = reject
//     document.head.appendChild(s)
//   })
// }

export function createMap (canvas, coords) {
  const map = L.map(canvas, {
    center: new L.LatLng(...coords),
    zoom: 16,
    attributionControl: false,
    scrollWheelZoom: false
  })

  let tonerUrl = 'https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}{r}.png'
  tonerUrl = tonerUrl.replace(/({[A-Z]})/g, function (s) {
    return s.toLowerCase()
  })
  map.addLayer(L.tileLayer(tonerUrl, {
    subdomains: 'abcd',
    minZoom: 0,
    maxZoom: 20,
    detectRetina: true
  }))
  // })

  var icon = L.icon({
    iconUrl: '/static/i/marker.png',
    iconSize: [28, 28],
    iconAnchor: [8, 8]
  })
  L.marker(coords, {icon: icon}).addTo(map)
}



// WEBPACK FOOTER //
// ./assets/j/src/map.js